/* ------------------------------------------------------
Motif Controller
------------------------------------------------------ */

Watcher.observe('.js-default-motif', elements => {
  // Loop the elements array
  elements.forEach(element => {
    // Create a new MagicScrolls instance for this element
    const Magic = new MagicScrolls(element.parentNode, {
      duration: 1000
    });

    // Set up a new Magic Tween
    Magic.tween(element, percentage => {
      if (window.innerWidth <= 768) return;
      element.style.transform = `translateY(${(-50 + percentage) * .4}%)`;
    });
  });
});